import { useGetOrganisation } from 'features/organisations/hooks/useGetOrganisation';
import { useParams } from 'react-router-dom';

export function ManagedOrganisationBreadcrumb() {
  const { managedOrganisationId = '' } = useParams();
  const { organisation } = useGetOrganisation(managedOrganisationId);

  return organisation?.name ?? managedOrganisationId;
}
